<template>
  <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
    
    <i class="fa fa-circle" :style="{ color: color }" style="padding: 0 10px; font-size: 10px" :title="backendStatus"></i>

    <RouterLink class="navbar-brand" to="/">
      <!--<strong>{{ name }}</strong>-->
      <strong>{{ name }}</strong>
      <!--<span class="subscript">{{ version }}</span>-->
      <span v-if="preApproval === false" class="subscript">v{{ version }}</span>
    </RouterLink>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" />
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
          
          
        <li class="nav-item" v-show="!$store.getters['user/isDistributor']" :class="{ active: $route.name === 'datasets' || $route.name === 'dataset' || $route.name === 'annotate' }">
          <RouterLink class="nav-link" to="/">My Images</RouterLink>
        </li>
        <li class="nav-item" :class="{ active: $route.name === 'dashboard' }">
          <RouterLink class="nav-link" to="/dashboard">
            Dashboard
          </RouterLink>
        </li>
        <li
          class="nav-item"
          v-show="$route.name === 'annotate'"
          :class="{ active: $route.name === 'annotate' }"
        >
          <RouterLink
            class="nav-link"
            :to="`/tabulardataset/${dataset.id}`"
          >
            {{ dataset.name }}
          </RouterLink>
        </li>

          
<!--
        <li class="nav-item" :class="{ active: $route.name === 'categories' }">
          <RouterLink class="nav-link" to="/categories">Categories</RouterLink>
        </li>
        <li class="nav-item" :class="{ active: $route.name === 'undo' }">
          <RouterLink class="nav-link" to="/undo">Undo</RouterLink>
        </li>

-->
          
         
          
        <!-- Admin 메뉴: operator와 admin 모두 표시 -->
        <li
          v-show="$store.getters['user/canManageUsers']"
          class="nav-item"
          :class="{ active: $route.path.indexOf('/admin') === 0 }"
        >
          <RouterLink class="nav-link d-none d-xl-block" to="/admin/users">Admin</RouterLink>
        </li>

        <!-- System 메뉴: admin만 표시 -->
        <li
          v-show="$store.getters['user/isAdmin']"
          class="nav-item"
          :class="{ active: $route.name === 'system-monitor' }"
        >
          <RouterLink class="nav-link d-none d-xl-block" to="/system">System</RouterLink>
        </li>

        <!-- API 메뉴: api 또는 both 타입 사용자만 표시 (on-premise가 아닌 경우) -->
        <li
          v-show="!isOnpremise && $store.getters['user/canAccessApi']"
          class="nav-item"
          :class="{ active: $route.name === 'api-keys' }"
        >
          <RouterLink class="nav-link" to="/api-keys">API</RouterLink>
        </li>
<!--
          <li class="nav-item d-none d-xl-block">
          <a
            class="nav-link"
            href="https://github.com/jsbroks/coco-annotator/wiki"
            >Help</a
          >
        </li>
-->
          
      </ul>
      <Status class="nav-link left" />
      <a
        v-if="faqUrl"
        :href="faqUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="nav-link text-white ml-2"
        title="Help & Support"
      >
        <i class="fa fa-question-circle-o"></i>
      </a>
      <SessionTimer v-if="loginEnabled" />
      <User class="nav-link left" v-if="loginEnabled" />
    </div>
  </nav>
</template>

<script>
import User from "@/components/User";
import Status from "@/components/Status";
import SessionTimer from "@/components/SessionTimer";

export default {
  name: "NavBar",
  components: { Status, User, SessionTimer },
  data() {
    return {
      color: "green",
      backendStatus: "Connected to backend"
    };
  },
  computed: {
    name() {
      return this.$store.state.info.name;
    },
    version() {
      return this.$store.state.info.version;
    },
    preApproval() {
      return this.$store.state.info.preApproval;
    },
    loginEnabled() {
      return this.$store.state.info.loginEnabled;
    },
    isOnpremise() {
      return this.$store.state.info.isOnpremise;
    },
    faqUrl() {
      return this.$store.state.info.faqUrl;
    },
    // socket() {
    //   return this.$store.state.info.socket;
    // },
    dataset() {
      let dataset = this.$store.state.dataset;
      if (dataset == null) return { name: "", id: "" };

      return dataset;
    }
  },
  watch: {
    // socket(connected) {
    //   if (connected == null) {
    //     this.color = "white";
    //     this.backendStatus = "Connection unknown";
    //     return;
    //   }

    //   if (connected) {
    //     this.color = "green";
    //     this.backendStatus = "Connected to backend";
    //   } else {
    //     this.color = "red";
    //     this.backendStatus = "Could not connect to backend";
    //   }
    // }
  }
};
</script>

<style scoped>
.subscript {
  padding: 10px;
  font-size: 10px;
  color: lightgray;
}

.navbar {
  background-color: #383c4a;
/*   background-color: #225AE6; */
}

.left {
  padding: 0;
}
</style>
